import { Badge } from "@/components/ui";
import { cn } from "@/lib/utils";
import {
  setMyCommunityCurrView,
  setUserData,
  setUserDataAction,
} from "@/redux/slices";
import { RootState } from "@/redux/store";
import { useGetPropertyOccupancyList } from "@/services";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { PROPERTIES, VIEW_USERS } from "../consts";
import { useEffect, useState } from "react";

const useUsers = () => {
  const [globalFilter, setGlobalFilter] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const propertyDetails = useSelector(
    (state: RootState) => state.currentData.propertyData
  );

  const propertyId = propertyDetails?.propertyId;

  //get properties
  const { data: propertyOwners, isLoading: isLoadingPropertyOwners } =
    useGetPropertyOccupancyList({
      propertyId: propertyId as string,
    });

  // Define Table Columns
  const columns = [
    {
      accessorKey: "userName",
      header: "User ID",
    },
    {
      accessorKey: "firstName",
      header: "First Name",
    },
    {
      accessorKey: "lastName",
      header: "Last Name",
    },
    {
      accessorKey: "occupancyType",
      header: "Occupant Type",
    },
    {
      accessorKey: "startDate",
      header: "Start Date",
      cell: (row: any) => {
        return row.row.original.startDate
          ? moment(row.row.original.startDate).format("MM/DD/YYYY")
          : "";
      },
    },
    {
      accessorKey: "endDate",
      header: "End Date",
      cell: (row: any) => {
        return row.row.original.endDate
          ? moment(row.row.original.endDate).format("MM/DD/YYYY")
          : "";
      },
    },
    {
      accessorKey: "status",
      header: (
        <div className="flex items-center w-[80px] justify-center gap-2">
          Status
        </div>
      ),
      cell: (row: any) => {
        return (
          <Badge
            variant="outline"
            className={cn(
              row.row.original.endDate
                ? "border-red-600 bg-red-100 text-red-600"
                : "border-green-600 bg-green-100 text-green-600",
              "rounded-full px-4 py-2"
            )}
          >
            {row.row.original.endDate ? "Inactive" : "Active"}
          </Badge>
        );
      },
    },
    {
      accessorKey: "mobileNo",
      header: "Mobile No.",
    },
  ];

  const onRowClick = (row: any) => {
    dispatch(setUserData(row.original));
    dispatch(setUserDataAction("view"));
    dispatch(setMyCommunityCurrView(VIEW_USERS));
  };

  const onCancel = () => {
    dispatch(setMyCommunityCurrView(PROPERTIES));
  };

  return {
    globalFilter,
    setGlobalFilter,
    columns,
    propertyOwners,
    isLoadingPropertyOwners,
    propertyDetails,
    onRowClick,
    onCancel,
  };
};

export default useUsers;
